module.exports = __webpack_public_path__ + "static/media/pic7.cd43a00b.jpg";